export default {
    METHOD_RUN_SUCCESSFULLY: "Метод успешно запущен",
    METHODS_RUN_SUCCESSFULLY: "Методы успешно запущены",
    SCRIPT_RUN_SUCCESSFULLY: "Скрипт успешно запущен"
};
